// extracted by mini-css-extract-plugin
export default {"base":"SearchPopover_base__05F8q","open":"SearchPopover_open__pY1Zp","title":"SearchPopover_title__H-Vtr","showing":"SearchPopover_showing__aPXnM"};